import React from 'react';
import { Redirect } from 'react-router';
import { TackShape, UserShape, WordShape } from '../shapes';
import PropTypes from 'prop-types';
import Waiting from './waiting';
import WordHeader from './word/header';

export default class Tack extends React.Component {
  static propTypes = {
    tack: TackShape,
    user: UserShape,
    word: WordShape,
    params: PropTypes.object,
    onReset: PropTypes.func,
    onTack: PropTypes.func,
  }

  componentDidMount() {
    this.props.onReset();
    this.props.onTack(this.props.params.wordText, this.props.params.targetLanguage);
  }

  render() {
    return (
      <div className='word'>
        <WordHeader wordText={this.props.params.wordText} pronunciationFile={this.props.word.get('pronunciationFile')} partOfSpeech={this.props.word.get('partOfSpeech')} mnemonicImageUrl={this.props.word.get('mnemonicImageUrl')} />
        { this.renderBody() }
      </div>
    );
  }

  renderBody() {
    if (this.props.tack.get('createdAt') || this.props.tack.get('tackError')) {
      return this.renderCreated();
    } else {
      return this.renderCreating();
    }
  }

  renderCreated() {
    return (
      <Redirect push to={ `/tacks/${ this.props.params.wordText }/confirmation` } />
    );
  }

  renderCreating() {
    return(
      <Waiting waitingText={ 'Crunching' } />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tack.jsx